import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from './shared/modules/header/header.module';
import { SideNavModule } from './shared/modules/side-nav/side-nav.module';
import { SortModule } from './shared/modules/sort/sort.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HeaderModule,
    SideNavModule,
    MatIconModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SortModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
